import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  conditionRow: {
    marginBottom: theme.spacing(3),

    '&:last-child': {
      marginBottom: 0,
    },
  },
  tagContainer: {
    marginBottom: theme.spacing(1.75),
  },
}));
